// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Fm","show":"Fn","dark":"Fo","top":"Fp","bottom":"Fq","left":"Fr","right":"Fs"};